import React, { memo } from "react";
import { Col, Form, Row, Input } from "antd";

export const Description = memo(({ description, getFieldDecorator }) => {
	const validateDescriptionStatus =
		description?.length === 400 ? "warning" : "";
	return (
		<Row gutter={8}>
			<Col span={24}>
				<Form.Item
					label="Описание"
					validateStatus={validateDescriptionStatus}
					help={
						validateDescriptionStatus
							? "Достигнут лимит в 400 символов"
							: undefined
					}
				>
					{getFieldDecorator("description", {
						initialValue: "",
					})(<Input.TextArea rows={3} maxLength={400} />)}
				</Form.Item>
			</Col>
		</Row>
	);
});
